import axiosInstance from 'service/axiosInstance';
import {
  NotificationListResponse,
  UnreadCountResponse,
  NotificationStatsResponse,
  NotificationFilters,
} from 'types/notifications';

// ─── List ─────────────────────────────────────────────────────────────────────

export const getNotifications = async (
  filters?: NotificationFilters,
): Promise<NotificationListResponse['response']> => {
  const response = await axiosInstance.get<NotificationListResponse>(
    'pmo/notifications',
    { params: filters },
  );
  const responseData = response.data.response as any;
  const list = responseData.data || responseData.content || [];
  if (Array.isArray(list)) {
    responseData.data = list.map((n: any) => ({
      ...n,
      isRead: n.isRead ?? n.read ?? false,
      createdAt: n.createdAt ?? n.createdDate ?? n.timestamp ?? new Date().toISOString(),
    }));
  }
  return responseData;
};

// ─── Unread Count & Stats ──────────────────────────────────────────────────────────────

export const getUnreadCount = async (): Promise<number> => {
  const response = await axiosInstance.get<UnreadCountResponse>(
    'pmo/notifications/unread-count',
  );
  return response.data.response.unreadCount;
};

export const getNotificationStats = async (): Promise<NotificationStatsResponse['response']> => {
  const response = await axiosInstance.get<NotificationStatsResponse>(
    'pmo/notifications/stats',
  );
  return response.data.response;
};

// ─── Mark Single as Read ───────────────────────────────────────────────────────

export const markNotificationAsRead = async (uuid: string): Promise<void> => {
  await axiosInstance.put(`pmo/notifications/${uuid}/read`);
};

// ─── Mark All as Read ─────────────────────────────────────────────────────────

export const markAllNotificationsAsRead = async (): Promise<void> => {
  await axiosInstance.put('pmo/notifications/read-all');
};

// ─── Delete Single ────────────────────────────────────────────────────────────

export const deleteNotification = async (uuid: string): Promise<void> => {
  await axiosInstance.delete(`pmo/notifications/${uuid}`);
};

// ─── Bulk Operations ──────────────────────────────────────────────────────────

export const bulkMarkNotificationsAsRead = async (notificationUuidList: string[]): Promise<void> => {
  await axiosInstance.put('pmo/notifications/bulk-read', { notificationUuidList });
};

export const bulkDeleteNotifications = async (notificationUuidList: string[]): Promise<void> => {
  await axiosInstance.delete('pmo/notifications/bulk-delete', { data: { notificationUuidList } });
};

// ─── Clear All ────────────────────────────────────────────────────────────────

export const clearAllNotifications = async (): Promise<void> => {
  await axiosInstance.delete('pmo/notifications/clear-all');
};
